const LOADER_ORIGIN = 'https://www.googletagmanager.com';

/* The container is loaded from script rather than from an inline snippet in index.html
   so the id can come from the build config, and so a build without a container ships no
   third-party request at all. The queue is why order does not matter: track() pushes
   into window.dataLayer before this runs, and the container replays what it finds.

   No <noscript> iframe counterpart: this page is a React bundle and renders nothing
   without JavaScript, so the fallback would measure an empty screen. */
export const installGtm = (containerId: string): void => {
  if (containerId === '') {
    return;
  }
  const src = `${LOADER_ORIGIN}/gtm.js?id=${containerId}`;
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }

  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};
